<template>
  <div class="home">
    <div class="wrapper-content">
      <div class="breadcrumb_box order">
        <div class="container-fluid">
          <h2>{{ $t('message.MyOrder') }}</h2>
        </div>
      </div>
      <div class="myorder" v-if="!allOrders.length">
        <h4 class="text-center mt-5">{{$t('message.OrderNotFound') }}</h4>
      </div>
      <div class="myorder" v-else>
        <div v-for="(item, index) in allOrders" :key="index">
          <div class="order-heading">
            <div class="container">{{item.date}}</div>
          </div>
          <div class="container">
            <div class="row">
              <div class="col-sm-12">
                <div class="order-detail panel">
                  <div role="tablist">
                    <b-card
                      no-body
                      class="myOrderLIst"
                      v-for="(order, index) in item.orderList"
                      :key="index"
                    >
                      <b-card-header header-tag="header" class role="tab">
                        <div v-b-toggle="'index_'+index" variant="info">
                          <div class="subsribe-list">
                            <div class="orderID">
                              {{ $t('message.Order') }} {{ $t('message.Id') }}- {{order.id}}
                              <div class="orderDateTime">{{newdate(order.created)}}</div>
                            </div>
                          </div>
                          <div class="active-block">
                            <p
                              class="confirmedOrder"
                              style="color:red"
                              v-if="order.order_status==='Cancelled'"
                            >{{order.order_status}}</p>
                            <p
                              class="confirmedOrder"
                              style="color:#d68a11"
                              v-else-if="order.order_status==='Processing'"
                            >{{order.order_status}}</p>
                            <p
                              class="confirmedOrder"
                              style="color:#0173bb"
                              v-else-if="order.order_status==='Confirmed'"
                            >{{order.order_status}}</p>
                            <p
                              class="confirmedOrder"
                              style="color:green"
                              v-else
                            >{{order.order_status}}</p>
                            <h2>
                              <sup>{{currency}}</sup>
                              {{order.total_price.toFixed(2)}}
                            </h2>
                          </div>

                          <div class="locationInfoDelivery">
                            <div class="map-icon">
                              <img class="svg" src="../assets/images/bag.svg" alt="placeholder" />
                            </div>
                            <div class="myOrderAddress">
                              <p>{{productNames(order.order_items)}}</p>
                            </div>
                          </div>

                          <div class="locationInfoDelivery">
                            <div class="map-icon">
                              <img
                                class="svg"
                                src="../assets/images/placeholder.svg"
                                alt="placeholder"
                              />
                            </div>
                            <div class="myOrderAddress">
                              <p>
                                <b>{{order.title}}:-</b>
                                {{order.location}}
                              </p>
                            </div>
                          </div>
                        </div>
                        <!-- <b-button block href="#" v-b-toggle.accordion-1 variant="info">Accordion 1</b-button> -->
                      </b-card-header>
                      <b-collapse :id="'index_'+index" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <div class="table-alignment">
                            <div class="imetable-new-custom">
                              <div>
                                <b>{{ $t('message.Delivery') }} {{ $t('message.Date') }}</b>
                                - {{order.delivery_date}}
                              </div>
                                
                              <div class="customdeliveryTime">
                                <b>{{ $t('message.Delivery') }} {{ $t('message.Time') }}</b>-
                                <div v-if="order.schedule_name=='MORN'">Morning</div>
                                <div v-if="order.schedule_name=='NOON'">Afternoon</div>
                                <div v-if="order.schedule_name=='EVEN'">Evening</div>
                               <div> ({{order.schedule_timing}})</div>
                              </div>
                            </div>
                            <div class="detail-order table-responsive">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th scope="col">{{ $t('message.Product') }}</th>
                                    <th scope="col">{{ $t('message.Price') }}</th>
                                    <th scope="col">{{ $t('message.Quantity') }}</th>
                                    <th scope="col">{{ $t('message.SubTotal') }}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(val, index) in order.order_items" :key="index">
                                    <td>{{val.product_name}}</td>
                                    <td>
                                      {{currency}}
                                      {{val.price_per_unit}}
                                    </td>
                                    <td>{{val.quantity}} {{val.unit}}</td>
                                    <td>{{currency}}{{val.price}}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </b-card-body>
                        <b-card-footer>
                          <div class="row">
                            <div
                              class="col-12"
                            >Delivery Charges - {{currency}}{{order.delivery_price.toFixed(2)}}</div>
                            <div class="col-12">
                              <div
                                v-on:click="cancelThisOrder(order.id)"
                                class="btn btn-primary pull-right"
                                v-if="order.order_status==='Confirmed'||order.order_status==='Processing'||order.order_status==='Delivered'"
                              >Cancel Order</div>
                              <div
                                to="#"
                                class="btn btn-primary pull-right"
                                v-b-modal="JSON.stringify(order.id)"
                              >Reorder</div>
                            </div>
                          </div>
                        </b-card-footer>
                      </b-collapse>
                      <b-modal :id="JSON.stringify(order.id)" title="Reorder">
                        <div class="delivery-select-new">
                          Select Delivery Date:
                          <div class="with-icon">
                            <button class="calendarBtn">
                              <i class="fa fa-calendar"></i>
                            </button>
                            <datepicker
                              ref="programaticOpen"
                              :disabled-dates="disabledDates"
                              v-model="deliveryDate"
                            ></datepicker>
                          </div>
                        </div>
                        <div
                          class="error"
                          v-if="!deliveryDate && submitStatus"
                        >{{ $t('message.DateValidation') }}</div>
                        <template v-slot:modal-footer>
                          <button
                            class="btn btn-primary"
                            v-on:click="reorder(order)"
                          >{{ $t('message.Submit') }}</button>
                        </template>
                      </b-modal>
                    </b-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMyOrders, cancelOrder, placeOrder } from "./../services/api";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Vuelidate from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Vue from "vue";
Vue.use(Vuelidate);
export default {
  components: {
    Datepicker
  },
  validations: {
    deliveryDate: {
      required
    }
  },
  data() {
    return {
      currency: localStorage.getItem("CurrencySymbol"),
      allOrders: [],
      deliveryDate: "",
      submitStatus: false,
      disabledDates: {
        to: new Date()
      }
    };
  },
  created() {
    this.getOrdersData();
  },
  methods: {
    openPicker() {
      this.$refs.programaticOpen.showCalendar();
    },
    cancelThisOrder(id) {
      if (confirm("Are you Sure you want to Cancel this Order?")) {
        if (!localStorage.getItem("userName")) {
          localStorage.clear();
          this.$router.push({ name: "register" });
        } else {
          var requestData = {
            user_id: localStorage.getItem("userId"),
            token: localStorage.getItem("token"),
            order_id: id,
            vendor_id: localStorage.getItem("vendorId")
          };

          cancelOrder(requestData)
            .then(result => {
              if (result.data.successCode === 1) {
                console.log(result);
              }
            })
            .catch(error => {
              return;
            });
        }
      }
    },
    reorder(order) {
      if (this.$v.$invalid) {
        this.submitStatus = true;
      } else {
        this.$bvModal.hide(JSON.stringify(order.id));
        if (!localStorage.getItem("userName")) {
          localStorage.clear();
          this.$router.push({ name: "register" });
        } else {
          if (localStorage.getItem("isPrepaid")) {
            var requestData = {
              address_id: order.address_id,
              delivery_date: moment(this.deliveryDate).format("DD MMMM, YYYY"),
              cart_total: this.currency + order.total_price,
              delivery_price: order.delivery_price,
              notes: order.notes,
              order: order.order_data,
              user_id: localStorage.getItem("userId"),
              token: localStorage.getItem("token"),
              duration_id: 1,
              payment_mode: order.payment_mode,
              type: "OTO",
              vendor_id: localStorage.getItem("vendorId")
            };
          } else {
            var requestData = {
              address_id: order.address_id,
              delivery_date: this.deliveryDate,
              cart_total: this.currency + order.total_price,
              delivery_price: order.delivery_price,
              notes: order.notes,
              order: order.order_data,
              user_id: localStorage.getItem("userId"),
              token: localStorage.getItem("token"),
              payment_mode: order.payment_mode,
              type: "OTO",
              vendor_id: localStorage.getItem("vendorId")
            };
          }

          placeOrder(requestData)
            .then(result => {
              if (result.data.successCode === 1) {
                console.log(result);
                this.getOrdersData();
              }
            })
            .catch(error => {
              return;
            });
        }
      }
    },
    productNames(orderArr) {
      var arr = [];
      for (var i = 0; i < orderArr.length; i++) {
        arr.push(orderArr[i].product_name);
      }

      return arr.join(", ");
    },
    newdate(value) {
      if (value) {
        return moment(value).format("DD MMMM, YYYY hh:mm A");
      }
    },
    getOrdersData() {
      if (!localStorage.getItem("userName")) {
        localStorage.clear();
        this.$router.push({ name: "register" });
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          token: localStorage.getItem("token"),
          limit: 10,
          page: 1,
          vendor_id: localStorage.getItem("vendorId")
        };

        getMyOrders(requestData)
          .then(result => {
            if (result.data.successCode === 1) {
              console.log("result", result);

              var a = result.data.orders;
              const groups = a.reduce((groups, x) => {
                const date = moment(x.created).format("MMMM-YYYY");

                if (!groups[date]) {
                  groups[date] = [];
                }

                groups[date].push(x);
                return groups;
              }, {});

              this.allOrders = Object.keys(groups).map(date => {
                return {
                  date,
                  orderList: groups[date]
                };
              });
            } else if (
              result.data.successCode === 0 &&
              result.data.messageCode === 1053
            ) {
              localStorage.clear();
              this.$router.replace({ name: "register" });
            }
          })
          .catch(error => {
            return;
          });
      }
    }
  }
};
</script>
